/* src/app/self-enrollment/verification-invalid/verification-invalid.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
button {
  background: none !important;
  border: none;
  padding: 0 !important;
  font-family: arial, sans-serif;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}
/*# sourceMappingURL=verification-invalid.component.css.map */
